import _ from 'lodash';
import { createSelector } from 'reselect';

import {
  selectServices,
  sortServicesByTypeAndCategory,
} from 'app/service/Selectors';

const selectSlug1 = (state, props) => _.get(props.params, 'slug1');
const selectSlug2 = (state, props) => _.get(props.params, 'slug2');

export const selectSearchQuery = state => state.explore.searchQuery;
export const selectServiceSortingRule = state =>
  state.explore.serviceSortingRule;

const selectSlugs = createSelector(selectSlug1, selectSlug2, (slug1, slug2) =>
  _.compact([slug1, slug2])
);

const findServiceBySlug = (services, slug) =>
  _.find(services, service => {
    return service.slug === slug;
  });

export const selectServicesFromSlugs = createSelector(
  selectServices,
  selectSlugs,
  (services, slugs) =>
    _.compact(slugs.map(slug => findServiceBySlug(services, slug)))
);

export const selectServicesFromSlugsWithZapier = createSelector(
  selectServices,
  selectServicesFromSlugs,
  (services, servicesFromSlugs) => {
    if (
      servicesFromSlugs.length === 1 &&
      servicesFromSlugs[0].key !== 'ZapierAPI' &&
      services.ZapierAPI
    ) {
      return servicesFromSlugs.concat(services.ZapierAPI);
    }

    return servicesFromSlugs;
  }
);

export const selectFilteredExploreServices = sortServicesByTypeAndCategory(
  selectServices,
  selectServiceSortingRule,
  selectSearchQuery
);

export const selectBlogPosts = state => state.explore.blogPosts.postData;
export const selectIsLoadingBlogPosts = state =>
  state.explore.blogPosts.isLoading;

export const selectIsLoadingRecommendedSharedZaps = state =>
  _.get(state, ['explore', 'recommendedSharedZaps', 'isLoading'], false);
export const selectPopularZapTemplateIds = state =>
  _.get(
    state,
    ['explore', 'recommendedSharedZaps', 'zapIds', 'by_matches_and_popularity'],
    []
  );
